<template>
  <div>
    <div v-if="isMobile">
      <app-history
        v-for="index in history.length"
        :key="index"
        :index="index - 1"
        :item="history[index - 1]"
        :selectedItem="selectedItem"
        @clicked="onClickItem"
        @removeRequest="removeRequest"
      >
      </app-history>
    </div>
    <div v-else>
      <v-data-table
        :items="history"
        item-key="Fserial"
        :headers="historyHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        show-expand
      >
        <template v-slot:[`item.Removable`]="{ item }">
          <v-btn
            class="grid"
            v-if="item.Removeable"
            color="red white--text"
            rounded
            @click="removeRequest(item)"
          >
            حذف درخواست
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>توضیحات طلبه: </b>{{ item.Comment }}
            <br />
            <br />
            <b>توضیحات مسئول آموزش: </b>{{ item.SchoolComment }}
            <br />
            <br />
          </td>
        </template>
      </v-data-table>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import History from "./History";
import Dialog from "@/components/Dialog";
import { removeRequest } from "@/api/delete-course";
export default {
  components: {
    appHistory: History,
    appDialog: Dialog,
  },
  data() {
    return {
      selectedItem: -1,

      historyHeaders: [
        {
          text: "وضعیت",
          value: "StrState",
          width: "15%",
        },
        {
          text: "شماره درخواست",
          value: "Fserial",
          width: "10%",
        },
        {
          text: "دوره",
          value: "NCycle",
          width: "15%",
        },
        {
          text: "درس",
          value: "NTitle",
          width: "35%",
        },
        {
          text: "تاریخ",
          value: "DDate",
          width: "10%",
        },        
        {
          text: "",
          value: "Removable",
          width: "10%",
          sortable: false,
        },

        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
    };
  },
  created() {
    this.$store.dispatch("getDeleteHistory");
  },
  computed: {
    history() {
      return this.$store.getters.deletedCoursesHistory;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    /**
     * expand khorooj
     */
    onClickItem(index) {
      if (this.selectedItem != index) {
        this.selectedItem = index;
      } else {
        this.selectedItem = -1;
      }
    },
    /**
     * show confirm dialog
     */
    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        removeRequest(index.Fserial, index.HashToken)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            
            if (data.Success) {
              this.$store.dispatch("getDeleteHistory");
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
            
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}
</style>
